import { Component, OnInit, TemplateRef, viewChild, inject } from '@angular/core';
import { FormService } from '../../services/form.service';
import {
  BrowserMessagesService,
  ModalRef,
  ModalService,
  TableColumn,
  TableComponent,
  LoaderComponent, SideMenuHeadlineComponent
} from '@rbb/ng-web-template-lib';
import { FormListItem } from '../../data/form-list-item';
import { EmployeeService } from '../../services/employee.service';
import { Employee } from '../../data/employee';
import { environment } from '../../../environments/environment';
import { OverviewListItem } from '../../data/overview-list-item';
import { RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { uniq } from 'lodash';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css'],
  imports: [RouterLink, DatePipe, TableComponent, LoaderComponent, SideMenuHeadlineComponent]
})
export class EditorComponent implements OnInit {
  private formService = inject(FormService);
  private browserMessagesService = inject(BrowserMessagesService);
  private modalService = inject(ModalService);
  private employeeService = inject(EmployeeService);

  transferSystems = environment.transferSystems;

  forms: FormListItem[] | undefined;
  productiveForms: OverviewListItem[] | undefined;
  selectedID: string | undefined;

  employee: Employee | undefined;

  columns: TableColumn[] | undefined;

  readonly ngModal = viewChild<TemplateRef<unknown>>('ngModal');
  ngModalService: ModalRef<unknown> | undefined;

  ngOnInit(): void {
    this.getForms();
    this.getEmployeeData();
    if (!environment.dataProtectionOfficer) {
      this.getProductiveForms();
    }
  }

  getForms(): void {
    this.formService.getEditableForms().subscribe({
      next: (next) => {
        this.forms = next;
        this.columns = [
          { name: 'Kategorie', field: 'groupName', type: 'string', selections: uniq(next.map(form => form.groupName)).filter(s => s).sort().map(groupName => ({ name: groupName!, value: groupName! })) },
          { name: 'Name', field: 'name', type: 'string' },
          { name: 'letzter Bearbeiter', field: 'createdByLastName', type: 'string' },
          { name: 'zuletzt bearbeitet', field: 'timestamp', type: 'Date' },
          { name: 'Datenschutz', field: 'approvalDataProtectionOfficer', type: 'string', selections: [
            { name: 'Ok', value: 'APPROVED' },
            { name: 'Abgelehnt', value: 'DECLINED' },
            { name: 'Warte auf Freigabe', value: 'PENDING' }
          ] },
          { name: 'Sichtbar', field: 'visible', type: 'boolean' },
          { name: '', field: 'edit', type: null },
          { name: '', field: 'history', type: null },
          { name: '', field: 'delete', type: null }
        ];
      },
      error: (error) => {
        this.browserMessagesService.showHttpError(error, 'Formulare konnten nicht geladen werden');
      }
    });
  }

  getProductiveForms(): void {
    this.formService.getProductiveVisibleFormsGroupless().subscribe(next => this.productiveForms = next);
  }

  isProductive(form: FormListItem): boolean {
    return !!this.productiveForms?.filter(f => f.tag === form.tag).length;
  }

  getEmployeeData(): void {
    this.employeeService.getMyApprovers().subscribe(
      (next) => {
        this.employee = next;
      }
    );
  }

  deleteForm(): void {
    if (this.selectedID) {
      this.formService.deleteForm(this.selectedID).subscribe({
        next: () => {
          this.closeModal();
          this.getForms();
        },
        error: (error) => {
          this.browserMessagesService.showHttpError(error, 'Formular konnte nicht gelöscht werden');
        }
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  altValueMapper(value: any): any {
    value.timestamp = new Date(value.timestamp);
    return value;
  }

  openModal(id: string): void {
    this.selectedID = id;
    const ngModal = this.ngModal();
    if (ngModal) {
      this.ngModalService = this.modalService.open(ngModal, { centered: true, backdrop: 'static' });
    }
  }

  closeModal(): void {
    this.ngModalService?.close();
  }
}
